var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader7ShapeB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69 792.35s-.33-212.36-.33-260V9.9A9.89 9.89 0 0112.25 0h1900.21a9.9 9.9 0 019.9 9.9c0 167.35-4.91 335.48 1.24 502.71-173.36-31.81-350.84-40.49-525.77-20.27-191 22.08-372.12 92.54-550.91 159.55C570.8 755.37 298.64 821.73 2.69 792.35z",
    fill: "#fff",
    opacity: 0.25
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO29wYWNpdHk6MC4yNTt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMi42OSw3OTIuMzVzLS4zMy0yMTIuMzYtLjMzLTI2MFY5LjlBOS44OSw5Ljg5LDAsMCwxLDEyLjI1LDBIMTkxMi40NmE5LjksOS45LDAsMCwxLDkuOSw5LjljMCwxNjcuMzUtNC45MSwzMzUuNDgsMS4yNCw1MDIuNzEtMTczLjM2LTMxLjgxLTM1MC44NC00MC40OS01MjUuNzctMjAuMjctMTkxLDIyLjA4LTM3Mi4xMiw5Mi41NC01NTAuOTEsMTU5LjU1QzU3MC44LDc1NS4zNywyOTguNjQsODIxLjczLDIuNjksNzkyLjM1WiIvPjwvc3ZnPg==";
export { SvgHeader7ShapeB as ReactComponent };